export default {
	message: {
		language: "中文",
		fittingLogin: "Fitting System Pro Edition Login",
		loading: "Loading...",
		scanToLogin: "Please used wechat scan the QR code to login/register",
		switchLanguage: "Switch Language",
		remainingDays: "Remaining {days} days",
		remainingTimes: "Remaining {times} times",
		newCustomer: "New Customer",
		name: "Name",
		gender: "Gender",
		age: "Age",
		contact: "Contact",
		fitter: "Fitter",
		date: "Date",
		del:"DelInfo",
		fittingRecords: "Fitting Records",
		editInfo: "Edit Info",
		viewCreate: "View/Create",
		addCustomer: "Add Customer",
		editCustomer: "Edit Customer",
		name: "Name",
		gender: "Gender",
		male: "Male",
		female: "Female",
		age: "Age",
		contact: "Contact",
		fitter: "Fitter",
		back: "Back",
		save: "Save",
		fittingRecordss: "'s Fitting Records",
		backToCustomerList: "Back to Customer List",
		newFitting: "New Fitting",
		name: "Name",
		time: "Time",
		status: "Status",
		actions: "Actions",
		notProvided: "Not Provided",
		downloadReport: "Download Report",
		completeReport: "Complete Report",
		continueFitting: "Continue Fitting"
	}
};